import { toast } from "react-toastify";

export const handleApiError = (error) => {
  if (error.response.status === 403) {
    toast.error(error.response.data.message);
  }
};

export const handleApiResponse = (resp) => {
  const { data, status } = resp;
  return { data, status };
};

export const packageStatus = {
  active: "Active",
  inactive: "Inactive",
};

export const propertyType = {
  hotel: "HOTEL",
  house_boat: "HOUSEBOAT",
};
